const testConfig = {
  baseUrl: 'https://th-test-api.dimorder.com',
};

export default testConfig;
